import { LOCATION_HISTORY_PATH_TYPES } from 'entities/navigation';

export const CARS_STATE = 'CARS';

export const CAR_NUMBER_ICON_WIDTH = 600;
export const CAR_NUMBER_ICON_HEIGHT = 48;

export const CAR_TYPES = {
  heavyTruck: 'heavyTruck',
  lightTruck: 'lightTruck',
  van: 'van',
  bus: 'bus'
} as const;

export const CAR_TYPE_SETTINGS = 'carTypeSettings' as const;

export const CAR_GROSS_WEIGHTS = {
  '3500Kg': 3500,
  '7500kg': 7500,
  '12000Kg': 12000,
  '18000Kg': 18000,
  '28000Kg': 28000,
  '32000Kg': 32000,
  '40000Kg': 40000,
};

export const CAR_EMISSION_TYPES = {
  euro1: 'euro1',
  euro2: 'euro2',
  euro3: 'euro3',
  euro4: 'euro4',
  euro5: 'euro5',
  euro6: 'euro6',
  euroEev: 'euroEev'
};

export const CAR_CO2_EMISSION_CLASSES = {
  class1: 1,
  class2: 2,
  class3: 3,
  class4: 4,
  class5: 5,
};

export const VEHICLE_TYPES = {
  unspecified: 0,
  truck: 1,
  bus: 2
};

export const CAR_NAVIGATION_HISTORY_PATH_TYPES = {
  ...LOCATION_HISTORY_PATH_TYPES,
  all: 'all'
} as const;

export const SHARED_ROUTE_HISTORY_URL_PATH_NAME = 'shared-route-history';

export const CAR_STATUSES = {
  inactive: 0,
  from0to4hours: 1,
  from4to10hours: 2,
  more10: 3
} as const;